import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  show(slug) {
    const url = apiRoutes.offerPath(1, slug);
    return FetchHelpers.get(url);
  },
};
